<!-- <footer class="mx-auto">
	<div class="footer align-items-center d-flex">
	  <div class="container-fluid">
		<div class="row">
		  <div class="col-sm-6 d-flex">
			<div class="imagewrapper">
			  <img class="footerimg" src="assets/images/logo-old@2x.png" />
			</div>
			<label class="copyright">Copyrighted © 2023</label>
		  </div>
		</div>
	  </div>
	</div>
  </footer>
   -->
   <div class="d-flex justify-content-between flex-wrap footer align-items-center" id="footer">
	<div class="left">
		<div class="image-cont" >
			<img src="assets/images/logo-old@2x.png" alt="logo" /> 
		</div>
		<span>Copyrighted © 2023</span>
	</div>
</div>